import * as React from 'react';
import styled from 'styled-components';
import { rem, rgba } from 'polished';
import {
  FlexCol,
  FlexColCenterVertical,
  FlexRow,
  FlexRowCenterVertical,
  TextP,
} from '../../..';
import { CountSetter } from '../Product/CountSetter';
import { StockInfo } from '../Product/StockInfo';
import { BigButtonWithRequest } from '../Product/BigButtonWithRequest';
import { FavoriteCompare } from './FavoriteCompare';
import { Watching } from '../Product/Watching';
import { __ } from 'react-i18n';
import { formatPrice, prop, round } from '../../../utilities';
import { SmallLoader } from '../General/SmallLoader';
import { Button } from '../General/Button';
import { scrollToElement } from '../Cart/utilities';

interface Props {
  product: any;
  price: number;
  oldPrice: number;
  sale: boolean;
  salePercentage: number;
  currency: string;
  avail_id: number;
  availability: string;
  count: number;
  handleCountChange: (newValue) => void;
  addToFavoriteOpen: () => void;
  addToCart: any;
  watchDogOpen: () => void;
  hasFavourite?: boolean;
  canOrder?: boolean;
  forbiddenOrder?: boolean;
  loadingPrices?: boolean;
  hasUser?: boolean;
  vocPrice: number;
  vocPriceWithoutVat: number;
  mocPrice: number;
  isB2B?: boolean;
  onStockCount?: number;
  saleEnded?: boolean;
  isPrelisting?: boolean;
  isNew: boolean;
  condition?: any;
  conditionTextMapping?: any;
  isWaiting?: boolean;
  showCompareIcon?: boolean;
  isCompare?: boolean;
  addToCompare: (productId:string) => void;
}

function ProductDetailPriceCart({
  product,
  price,
  oldPrice,
  sale,
  salePercentage,
  currency,
  avail_id,
  availability,
  count,
  handleCountChange,
  addToFavoriteOpen,
  addToCart,
  watchDogOpen,
  hasFavourite = true,
  canOrder,
  forbiddenOrder,
  loadingPrices,
  hasUser,
  vocPrice,
  vocPriceWithoutVat,
  mocPrice,
  isB2B,
  onStockCount,
  saleEnded,
  isPrelisting,
  isNew,
  condition,
  conditionTextMapping,
  isWaiting,
  showCompareIcon,
  isCompare,
  addToCompare
}: Props) {

  const isAvailable = avail_id === 1;
  const unAvailable = avail_id === 11 || !avail_id;

  const onClickAlternativeButtonDesktop = event => {
    onClickAlternativeButton(event, 'product_tabs');
  };

  const onClickAlternativeButtonMobile = event => {
    onClickAlternativeButton(event, 'alternative_tab_mobile');
  };

  const onClickAlternativeButton = (event, className) => {
    event.stopPropagation();
    scrollToElement(className);
  };

  const units = prop(product, 'main_good.units');

  return (
    <>
      {saleEnded || isPrelisting /*&& !price*/ ? (
        <>
          <AlternativesButtonDesktop onClick={onClickAlternativeButtonDesktop}>
            {' '}
            {__('Alternatívy')}{' '}
          </AlternativesButtonDesktop>
        </>
      ) : (
        <Wrapper
          avail_id={avail_id}
          canOrder={canOrder}
          isNew={isNew}
          isWaiting={isWaiting}
        >
          {isB2B ? (
            <PriceRow>
              <OldPrice>
                {`${__('VOC s DPH')}: `}
                {formatPrice(vocPrice, currency, 2)}
              </OldPrice>

              {oldPrice > vocPrice && oldPrice > 0 ? (
                <OldPrice>
                  {`${__('Maloobchodná cena')}: `}
                  {formatPrice(+oldPrice, currency, 2)}
                  {salePercentage ? ` (-${round(salePercentage, 0)}%)` : ''}
                </OldPrice>
              ) : null}
            </PriceRow>
          ) : (
            <></>
          )}
          {/* {isB2B && (
            <PriceRow>
              {oldPrice > 0 ? (
                <OldPrice>
                  {`${__('Akcia MOC')}: `}
                  {formatPrice(mocPrice, currency, 2)}
                </OldPrice>
              ) : (
                <OldPrice>
                  {`${__('MOC')}: `}
                  {formatPrice(mocPrice, currency, 2)}
                </OldPrice>
              )}
            </PriceRow>
          )} */}
          <PriceRow>
            {unAvailable ? (
              <Soon>{__(`UŽ ČOSKORO`)}</Soon>
            ) : (
              <>
                <Price avail_id={avail_id} canOrder={canOrder}>
                  <span className="kl1">
                    {(!isB2B && price > 0) || (isB2B && vocPriceWithoutVat > 0)
                      ? formatPrice(
                          isB2B ? vocPriceWithoutVat : price,
                          currency,
                          2,
                        )
                      : __('Na požiadanie')}

                    {!!units && units !== 'ks' ? (
                      <StyledUnitText>{`${__(
                        'cena za',
                      )} ${units}`}</StyledUnitText>
                    ) : (
                      <></>
                    )}
                    {isB2B ? (
                      <VocNoVatSpan>
                        {price > 0 && ` ${__('VOC bez DPH')}`}
                      </VocNoVatSpan>
                    ) : (
                      <></>
                    )}
                  </span>
                  {/* {loadingPrices && (
                    <LoaderWrapper>
                      <SmallLoader
                        title={__('Prebieha načítanie cien')}
                        small={true}
                        primaryColor={true}
                      />
                    </LoaderWrapper>
                  )} */}
                </Price>

                {isB2B ? (
                  <>
                    {mocPrice > vocPriceWithoutVat && (
                      <OldPrice>
                        {oldPrice > 0
                          ? `${__('Akčná cena s DPH')}: `
                          : `${__('MOC s DPH')}: `}
                        {formatPrice(mocPrice, currency, 2)}
                      </OldPrice>
                    )}
                  </>
                ) : (
                  <>
                    {round(+oldPrice, 2) > round(+price, 2) ? (
                      sale ? (
                        <OldPrice>
                          {`${__('Pôvodná cena')}: `}
                          {formatPrice(oldPrice, currency, 2)}
                          {` (-${round(salePercentage, 0)}%)`}
                        </OldPrice>
                      ) : oldPrice > 0 ? (
                        <OldPrice>
                          {`${__('Pôvodná cena')}: `}
                          {formatPrice(oldPrice, currency, 2)}
                          {salePercentage
                            ? ` (-${round(salePercentage, 0)}%)`
                            : ''}
                        </OldPrice>
                      ) : null
                    ) : null}
                  </>
                )}
              </>
            )}
          </PriceRow>

          {(price > 0 && !forbiddenOrder) && (
            <ButtonsRow>
              {unAvailable ? (
                <Watching watchDogOpen={watchDogOpen} />
              ) : (
                <>
                  {canOrder && (
                    <CountSetter
                      count={count}
                      onChange={handleCountChange}
                      hasMarginRight={true}
                    />
                  )}
                  <BigButtonWithRequest
                    product={product}
                    avail_id={avail_id}
                    addToCart={addToCart}
                    count={count}
                    canOrder={canOrder}
                    isNew={isNew}
                    isWaiting={isWaiting}
                  />
                </>
              )}
               <FavoriteCompare
                  id={product.product_id}
                  addToFavoriteOpen={addToFavoriteOpen}
                  hasFavourite={false}
                  isCompare={isCompare}
                  showCompareIcon={showCompareIcon}
                  addToCompare={addToCompare}
                /> 
            </ButtonsRow>
          )}

          {canOrder && (
            <StockInfo
              avail_id={avail_id}
              availability={availability}
              onStockCount={onStockCount}
              isNew={isNew}
              isWaiting={isWaiting}
              condition={condition}
              conditionTextMapping={conditionTextMapping}
            />
          )}
        </Wrapper>
      )}
      {!saleEnded ? (
        <MobileWrapper avail_id={avail_id} canOrder={canOrder}>
          <MobilePriceRow>
            {unAvailable ? (
              <Soon>{__(`UŽ ČOSKORO`)}</Soon>
            ) : (
              <>
                <Price avail_id={avail_id} canOrder={canOrder}>
                  {' '}
                  {price > 0
                    ? formatPrice(price, currency, 2)
                    : __('Na požiadanie')}
                  {!!units && units !== 'ks' && (
                    <StyledUnitText>{`${__(
                      'cena za',
                    )} ${units}`}</StyledUnitText>
                  )}
                  {/* {loadingPrices && (
                    <LoaderWrapper>
                      <SmallLoader
                        title={__('Prebieha načítanie cien')}
                        small={true}
                        primaryColor={true}
                      />
                    </LoaderWrapper>
                  )} */}
                </Price>
                {round(oldPrice, 2) > round(price, 2) ? (
                  sale ? (
                    <OldPrice>
                      {`${__('Pôvodná cena')}: `}
                      {formatPrice(oldPrice, currency, 2)}
                      {` (-${round(salePercentage, 0)}%)`}
                    </OldPrice>
                  ) : (
                    <OldPrice>
                      {' '}
                      {`${__('Maloobchodná cena')}: `}
                      {formatPrice(oldPrice, currency, 2)}
                      {salePercentage ? ` (-${round(salePercentage, 0)}%)` : ''}
                    </OldPrice>
                  )
                ) : null}
              </>
            )}
          </MobilePriceRow>
          <MobileButtonsCol>
            {unAvailable ? (
              <Watching watchDogOpen={watchDogOpen} />
            ) : (
              <>
                <MobileCountFavComp>
                  {canOrder && (
                    <CountSetter
                      count={count}
                      onChange={handleCountChange}
                      hasMarginRight={true}
                    />
                  )}
                  <FavoriteCompare
                    id={product.product_id}
                    addToFavoriteOpen={addToFavoriteOpen}
                    hasFavourite={false}
                    isCompare={isCompare}
                    showCompareIcon={showCompareIcon}
                    addToCompare={addToCompare}
                  /> 
                </MobileCountFavComp>
                {(price > 0 && !forbiddenOrder) && (
                  <BigButtonWithRequest
                    avail_id={avail_id}
                    addToCart={addToCart}
                    product={product}
                    count={count}
                    canOrder={canOrder}
                    isNew={isNew}
                    isWaiting={isWaiting}
                  />
                )}
              </>
            )}
            {canOrder && (
              <StockInfo
                avail_id={avail_id}
                availability={availability}
                onStockCount={onStockCount}
                isNew={isNew}
                isWaiting={isWaiting}
                condition={condition}
                conditionTextMapping={conditionTextMapping}
              />
            )}
          </MobileButtonsCol>
        </MobileWrapper>
      ) : (
        <>
          <AlternativeButtonMobile onClick={onClickAlternativeButtonMobile}>
            {' '}
            {__('Alternatívy')}{' '}
          </AlternativeButtonMobile>
        </>
      )}
    </>
  );

  return (
    <>
      <Wrapper avail_id={avail_id}>
        <PriceRow>
          {unAvailable ? (
            <Soon>{`UŽ ČOSKORO`}</Soon>
          ) : (
            <>
              <Price avail_id={avail_id}>
                {' '}
                {price > 0
                  ? `${price.toFixed(2)} ${currency}`
                  : __('Na požiadanie')}
              </Price>
              {sale && (
                <OldPrice>{`Pôvodná cena: ${oldPrice} ${currency} (-${salePercentage}%)`}</OldPrice>
              )}
            </>
          )}
        </PriceRow>
        <ButtonsRow>
          {unAvailable ? (
            <Watching watchDogOpen={watchDogOpen} />
          ) : (
            <>
              {false && (
                <CountSetter
                  count={count}
                  onChange={handleCountChange}
                  hasMarginRight={true}
                />
              )}
              <BigButtonWithRequest
                product={product}
                avail_id={avail_id}
                addToCart={addToCart}
                count={count}
                isNew={isNew}
              />
            </>
          )}
          <FavoriteCompare
            id={product.product_id}
            addToFavoriteOpen={addToFavoriteOpen}
            hasFavourite={false}
            addToCompare={() => {}}
          />
        </ButtonsRow>
        <StockInfo
          avail_id={avail_id}
          availability={availability}
          onStockCount={onStockCount}
        />
      </Wrapper>
      <MobileWrapper avail_id={avail_id}>
        <MobilePriceRow>
          {unAvailable ? (
            <Soon>{`UŽ ČOSKORO`}</Soon>
          ) : (
            <>
              <Price avail_id={avail_id}>
                {' '}
                {price > 0
                  ? `${price.toFixed(2)} ${currency}`
                  : __('Na požiadanie')}
              </Price>
              {sale && (
                <OldPrice>{`Pôvodná cena: ${oldPrice} ${currency} (-${salePercentage}%)`}</OldPrice>
              )}
            </>
          )}
        </MobilePriceRow>
        <MobileButtonsCol>
          {unAvailable ? (
            <Watching watchDogOpen={watchDogOpen} />
          ) : (
            <>
              <MobileCountFavComp>
                {false && (
                  <CountSetter
                    count={count}
                    onChange={handleCountChange}
                    hasMarginRight={true}
                  />
                )}
                <FavoriteCompare
                  id={product.product_id}
                  addToFavoriteOpen={addToFavoriteOpen}
                  hasFavourite={false}
                  addToCompare={() => {}}
                />
              </MobileCountFavComp>
              <BigButtonWithRequest
                avail_id={avail_id}
                addToCart={addToCart}
                product={product}
                count={count}
                isNew={isNew}
              />
              <StockInfo
                avail_id={avail_id}
                availability={availability}
                onStockCount={onStockCount}
              />
            </>
          )}
        </MobileButtonsCol>
      </MobileWrapper>
    </>
  );
}

const Wrapper = styled.div<{
  avail_id: number;
  canOrder?: boolean;
  isNew?: boolean;
  isWaiting?: boolean;
}>`
  padding: ${rem(24)};
  background-color: ${({ theme, avail_id, canOrder, isNew, isWaiting }) =>
    canOrder
      ? isWaiting
        ? theme.colors.stockCountExpectingFair
        : avail_id === 1
        ? theme.colors.stockCountAvailableFair
        : isNew
        ? theme.colors.stockCountExpectingFair
        : avail_id === 2
        ? theme.colors.stockCountSoldFair
        : theme.colors.stockCountUnavailableFair
      : rgba(theme.colors.primary, 0.08)};
  ${({ theme }) => theme.mediab.m600`
    display: none;
  `}
`;

const MobileWrapper = styled(Wrapper)`
  display: none;
  ${({ theme }) => theme.mediab.m600`
    display: block;
    padding-left: ${rem(16)};
    padding-right: ${rem(16)};
  `}
`;

const PriceRow = styled(FlexRow)`
  justify-content: space-between;
  margin-bottom: ${rem(16)};
  position: relative;
`;

const LoaderWrapper = styled.div`
  position: absolute;
  top: -${rem(32)};
  right: -${rem(16)};
`;

const MobilePriceRow = styled(FlexCol)`
  margin-bottom: ${rem(16)};
`;

const ButtonsRow = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(16)};
`;

const MobileButtonsCol = styled(FlexColCenterVertical)``;

const MobileCountFavComp = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(16)};
  justify-content: space-between;
`;

const VocNoVatSpan = styled.span`
  font-size: ${rem(14)};
  margin-left: ${rem(8)};
`;

const Price = styled(TextP)<{ avail_id: number; canOrder?: boolean }>`
  font-size: ${rem(24)};
  font-weight: 500;
  color: ${({ theme, avail_id, canOrder }) =>
    canOrder
      ? avail_id === 1
        ? theme.colors.stockCountAvailable
        : avail_id === 2
        ? theme.colors.stockCountSold
        : theme.colors.textPrimary
      : theme.colors.primary};
  ${({ theme }) => theme.mediab.l925`
    margin-bottom: ${rem(4)};
  `}
  line-height: ${rem(24)};
  position:relative;
  width: fit-content;
`;

const StyledUnitText = styled.p`
  margin: 0;
  opacity: 0.4;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(14)};
`;

const OldPrice = styled(TextP)``;

const Soon = styled(TextP)`
  font-weight: 500;
  font-size: ${rem(24)};
`;

const AlternativesButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 300;
  height: ${rem(56)};
  margin: ${rem(20)};

  &:hover {
    filter: brightness(90%);
    transition: filter 0.2s ease;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
  }

  ${({ theme }) => theme.mediab.l925`
    font-weight: 400;
  `}
`;

const AlternativesButtonDesktop = styled(AlternativesButton)`
  ${({ theme }) => theme.mediab.m600`
    display: none;
  `}
`;

const AlternativeButtonMobile = styled(AlternativesButton)`
  display: none;
  ${({ theme }) => theme.mediab.m600`
    display: block;
  `}
`;

export { ProductDetailPriceCart };
